import styles from './DocsSidebar.module.css'

const sections = [
  { id: 'getting-started', label: 'Getting Started' },
  { id: 'lifecycle', label: 'Lifecycle' },
  { id: 'color-palette', label: 'Color Palette' },
  { id: 'button-reference', label: 'Button Reference' },
  { id: 'constraints', label: 'Constraints' },
  { id: 'drawing', label: 'Drawing' },
  { id: 'input', label: 'Input' },
  { id: 'sprites', label: 'Sprites' },
  { id: 'palette', label: 'Palette' },
  { id: 'camera-clipping', label: 'Camera & Clipping' },
  { id: 'map', label: 'Map' },
  { id: 'math', label: 'Math' },
  { id: 'random', label: 'Random' },
  { id: 'strings', label: 'Strings' },
  { id: 'arrays', label: 'Arrays' },
  { id: 'audio', label: 'Audio' },
  { id: 'debug', label: 'Debug' },
]

export function DocsSidebar() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <nav className={styles.sidebar}>
      <div className={styles.title}>Documentation</div>
      {sections.map((s) => (
        <button
          key={s.id}
          className={styles.link}
          onClick={() => scrollTo(s.id)}
        >
          {s.label}
        </button>
      ))}
    </nav>
  )
}
